import { render, staticRenderFns } from "./FigmaImageLayer.vue?vue&type=template&id=cae017ea&scoped=true"
import script from "./FigmaImageLayer.vue?vue&type=script&lang=js"
export * from "./FigmaImageLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae017ea",
  null
  
)

export default component.exports